import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { loadProfileStart } from '../../redux/modules/profile'
import { selectUserLocationId } from '../../redux/modules/selectors'
import { currentUserStart } from '../../redux/modules/user'
import { locationRoute, loginRoute } from '../../routes/routes'
import { formatUrl } from '../../util/formatUtils'
import { SimpleSpinner } from '../common/SimpleSpinner'

class HomeRedirect extends Component {
  componentDidMount() {
    this.props.currentUserStart(true, true)
    this.props.loadProfileStart()
  }

  render() {
    const { isAuthenticated, isCurrentUserLoading, isLoadingProfile, locationId } = this.props
    if ((isCurrentUserLoading && !isAuthenticated) || isLoadingProfile) {
      return <SimpleSpinner />
    } else {
      return locationId && locationId > 0 ? (
        <Redirect to={formatUrl(locationRoute.path, { locationId: locationId })} />
      ) : (
        <Redirect to={loginRoute.path} />
      )
    }
  }
}

const mapStateToProps = state => {
  const locationId = selectUserLocationId(state)
  const { isAuthenticated, isCurrentUserLoading } = state.user
  const { isLoadingProfile, profile } = state.profile
  return {
    isAuthenticated,
    isCurrentUserLoading,
    isLoadingProfile,
    locationId,
    profile,
  }
}
const mapDispatchToProps = {
  currentUserStart,
  loadProfileStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeRedirect)
